<template>
  <div class="layer" style="background: #fff">
    <div class="blog-view">
      <h1>基于病毒学文献数据集的情报分析</h1>
      <div class="blog-sub">
        <span>中国工程科技知识中心</span>
        <span>2020-02-13 15:03:17</span>
      </div>
      <div class="blog-content">
        <p>2019新型冠状病毒（2019 novel Coronavirus，以下简称2019-nCov）在武汉爆发，2020年1月30日WHO宣布将新型冠状病毒感染肺炎疫情列为国际关注的突发公共卫生事件（PHEIC）。冠状病毒（Coronaviruses、CoV）肆虐全球，成为所有人关注的焦点。</p>
        <p>浙江大学文献信息分析与应用中心（https://ciraa.zju.edu.cn/）、中国工程院知识中心中国工程科技机构与专家库（http://expert.ckcest.cn）课题组基于Web of Science数据库，利用关键词对法构建发布了病毒学研究文献数据集，涵盖了病毒学领域2003-2018的研究文献322094篇，1839840条学者与研究机构信息，我们基于上述数据集进行了一些分析与探索，希望有助于学者的进一步合作与研究。</p>
        <p>
          <strong>病毒学及传染病学研究概况</strong>
        </p>
        <p>采用构建的相关研究数据集，统计数据按学者姓名和其所在机构聚类，如同机构同名学者将被认为是一位学者。我们对发文量前20的学者的研究内容进行聚类，按发文量指标进行排序后，得到前20的学者数据如表1所示。</p>
        <p><br></p>
        <div class="pgc-img">
          <img src="http://p1.pstatp.com/large/pgc-image/04f4124b73c143a686d0fae4549470c8" img_width="577" img_height="554" alt="基于病毒学文献数据集的情报分析" inline="0">
          <p class="pgc-img-caption"></p>
        </div>
        <p><br></p>
        <div class="pgc-img">
          <img src="http://p1.pstatp.com/large/pgc-image/948a3af832f345bd81ae00204363a079" img_width="546" img_height="303" alt="基于病毒学文献数据集的情报分析" inline="0">
          <p class="pgc-img-caption"></p>
        </div>
         <p>
          <strong>冠状病毒的研究</strong>
        </p>
        <p>将上述专家研究方向按云图展示发现病毒学领域的主要研究关注是艾滋病（HIV）,而冠状病毒是一个相对细化的分支，因此病毒学TOP20的学者中并没有研究者以coronavirus（冠状病毒）作为主要研究方向。</p>
        <p>为此我们从数据集中抽取coronavirus有关的关键词数据共计22个关联关键词，主要内容为冠状病毒及具体症状，如：MERS、MERS-CoV、severe acute respiratory syndrome (SARS)、SARS virus等，除此之外，也有一些上级词汇，如：Evolution（进化）、Vaccine（疫苗）等，如下图。</p>
        <p><br></p>
        <div class="pgc-img">
          <img src="http://p1.pstatp.com/large/pgc-image/d2ef04fd7ab84830bd354395be707e75" img_width="558" img_height="336" alt="基于病毒学文献数据集的情报分析" inline="0">
          <p class="pgc-img-caption"></p>
        </div>
        <p>通过对冠状病毒研究的共词，按出现最早年份排序，可以获得冠状病毒研究的研究过程树。从图3中可以看出冠状病毒的研究源于自身免疫性（Autoimmunity）研究（1990年），其下级节点包含SARS（2003年）,MERS（2014年）, 突刺蛋白 (Spike Protein，2017年), 猪流行性腹泻病毒 (PEDV，2019年)。其中SARS有关论文发文年度为：2003-2018，共计155篇；MERS有关论文发文年度为：2014-2018，共计1829篇。由上述数据可知，MERS所引发的关注远比SARS集中而持久，由于其超高的致死率，学术界对其倾注了极大的研究资源。</p>
        <p><br></p>
        <div class="pgc-img">
          <img src="http://p3.pstatp.com/large/pgc-image/c8cee3000401452381e1b25c8b4721b3" img_width="489" img_height="434" alt="基于病毒学文献数据集的情报分析" inline="0">
          <p class="pgc-img-caption"></p>
        </div>
        <p>通过上述冠状病毒相关的22个关键词对，在数据集中二次检索收敛获取冠状病毒TOP20研究学者结果（因为发文数量并列，实际选取23名）如表2所示。</p>
        <p><br></p>
        <div class="pgc-img">
          <img src="http://p3.pstatp.com/large/pgc-image/11b3e3c63024449688aca8daf2c4cf4f" img_width="579" img_height="521" alt="基于病毒学文献数据集的情报分析" inline="0">
          <p class="pgc-img-caption"></p>
        </div>
        <p><br></p>
        <div class="pgc-img">
          <img src="http://p1.pstatp.com/large/pgc-image/6d4f2504f02b480393aa9f3e1ecfee96" img_width="554" img_height="535" alt="基于病毒学文献数据集的情报分析" inline="0">
          <p class="pgc-img-caption"></p>
        </div>
        <p><br></p>
        <div class="pgc-img">
          <img src="http://p9.pstatp.com/large/pgc-image/544cedac312944dcb441fbc03ec8da49" img_width="554" img_height="108" alt="基于病毒学文献数据集的情报分析" inline="0">
          <p class="pgc-img-caption"></p>
        </div>
        <p>从表2可以看到香港大学的袁国勇（Yuen,Kwok-Yung）院士以相关研究成果45篇位列第一。同时,在冠状病毒研究TOP20学者中,香港大学学者占据7位。可见我国香港地区对冠状病毒有着持久的研究和长足的人才储备,未来极有可能在此领域产生重要的学术成果和解决方案。</p>
        <p>我们以袁国勇院士为例进行文献计量分析。</p>
        <p><br></p>
        <div class="pgc-img">
          <img src="http://p9.pstatp.com/large/pgc-image/146f74928c7c4934b110eb44b188f57a" img_width="345" img_height="251" alt="基于病毒学文献数据集的情报分析" inline="0">
          <p class="pgc-img-caption"></p>
        </div>
        <p>袁国勇，中国工程院院士,2001年至2011年担任香港大学微生物学系主任,2005年担任香港大学新发传染性疾病国家重点实验室首任主任,2020年,担任国家卫生健康委员会高级别专家组成员。</p>
        <p>袁国勇院士在2013-2018年间对冠状病毒和SARS的研究共计发文29篇,在发现引起非典型肺炎的病原体方面,袁国勇院士发挥了关键作用,并在《柳叶刀》上发表了第一篇关于甲型H5N1流感的临床和实验室诊断论文。</p>
        <p>截止2019年,袁国勇院士已在《Lancet》、《New England Journal of Medicine》、《Science》、《Journal of Virology and PNAS》等顶级医学期刊发表超过900篇学术论文,被引用超过36000次,主要的研究方向如图5所示,近期主要SCI医学期刊发文情况如图6所示。</p>
        <p><br></p>
        <div class="pgc-img">
          <img src="http://p1.pstatp.com/large/pgc-image/c3f749d433ba4c04a829469a99bc1b05" img_width="539" img_height="474" alt="基于病毒学文献数据集的情报分析" inline="0">
          <p class="pgc-img-caption"></p>
        </div>
        <p>我们同时通过中国工程科技机构与专家库网站检索“冠状病毒”，发现袁院士也是相关研究领域专家推荐的榜首。</p>
        <p><br></p>
        <div class="pgc-img">
          <img src="http://p1.pstatp.com/large/pgc-image/32f7d2645a1a4e6cb2dd7c80f8c82567" img_width="513" img_height="348" alt="基于病毒学文献数据集的情报分析" inline="0">
          <p class="pgc-img-caption"></p>
        </div>
        <p>通过对冠状病毒关联文章中的机构进行聚类,得到冠状病毒主要研究机构如表3所示,以香港大学位居首位。其中,中国的冠状病毒的主要研究机构有香港大学、中国科学院、中国医学科学院。</p>
        <p><br></p>
        <div class="pgc-img">
          <img src="http://p1.pstatp.com/large/pgc-image/6f2c898409df4414b8813f05bd4ed187" img_width="482" img_height="518" alt="基于病毒学文献数据集的情报分析" inline="0">
          <p class="pgc-img-caption"></p>
        </div>
        <p>全球对冠状病毒研究的国家有55个,覆盖亚洲、欧洲和美洲的绝大部分国家和地区,其研究热度分布如图8所示。可以明显看到，热点研究区域主要集中在美国和中国，我们预计，对于此次疫情的防控和治疗方案也将依赖中美两国的研究与合作取得突破。</p>
        <p><br></p>
        <div class="pgc-img">
          <img src="http://p1.pstatp.com/large/pgc-image/e3f370f8e03744c59038792b55a1bc70" img_width="554" img_height="320" alt="基于病毒学文献数据集的情报分析" inline="0">
          <p class="pgc-img-caption"></p>
        </div>
        <p>中国工程院中国工程科技知识中心</p>
        <p>浙江大学信息资源分析与应用中心</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'blog1',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>

<style lang="scss">
.layer{
  .blog-view{
    margin-top: 5vh;
    width: 50vw;
    .blog-sub{
      margin-top: 12px;
      margin-bottom: 20px;
      font-size: 13px;
      span{
        color: #777;
        margin-right: 2px;
      }
    }
    .blog-content{
      font-size: 16px;
      line-height: 28px;
      color: #222;
      word-wrap: break-word;
      p{
        margin-top: 16px;
        margin-bottom: 16px;
      }
      strong{
        font-weight: 700;
      }
      .pgc-img{
        font-size: 16px;
        line-height: 28px;
        color: #222;
        word-wrap: break-word;
        img{
          max-width: 100%;
          display: block;
          margin: 10px auto;
        }
        .article-img-caption{
          position: relative;
          margin-left: 10px;
          padding-left: 16px;
          text-align: center;
          font-size: 12px;
          line-height: 16px;
          color: #999;
        }
        .article-img-caption::before{
          content: "";
          position: relative;
          padding-left: 16px;
          text-align: center;
          background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAbCAYAAACN1PRVAAAAAXNSR0IArs4c6QAAAZ9JREFUSA3llL9Kw1AUxvMHByGQFyi4pBBdM/gUYgZfQtDdxU3BUWgR3B0cdfEdHNwEUxqLqFOETm7553diGmhymp6rzaIXQnO/e8/59Zx7v2jaXx26amGTyWQjjuMt0zQfHcd5U4k3VDYHQXAM0HOe53dpmr6MRqMjlXhxZQDtIvENk9x3XfeW0RuSqLIoiixd14eNaAik0zq3VtdEsOl0eoLW9erBNCed1rm1ura0jWEYejifeyQ168GzOapLcWG2cWEeZhr321oZAZIkuWwDUVLpvlYYbtshcnncv2Q0r9zPLH1LC9s4Ho97aN8TtokOvyR8op2b/X7/nSMurCzLsoEiiPJbZRzH0lgY2uHjHHw2YolIcRTPbWvASs9QVb8ZA857DVibp6R0VMd6b+6CSDwlBXLeqyqTekUK4/JVMEVPSZlz3iva+ENPSYGV94rK4I1TRKqYVwqifRY+Dmf0YlBv8ezQpKuBy7IHxhpVhnd9vSsQ5QWIOJkBUIKXaxI7HFfgpMWZ2bZ9gMkFno8VA18NwzjHx3l/xXn/c7ovwH/SGRgoOLUAAAAASUVORK5CYII=) no-repeat 50%;
          background-size: cover;
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/view/blog/blog2.vue